import React, { useState, useEffect, useRef, useContext } from 'react';
import { deliveryPanelStyle, summaryPanelStyle } from './AirtimePlanningStyles';
import PlanDelivery from './PlanDelivery/PlanDelivery';
import PlanManager from './PlanManager';
import PlanSummary from './PlanSummary';
import PlanChart from './PlanChart/PlanChart';
import { BusinessTypes } from '../../../constants/Enums';
import {
    GetCampaignBursts,
    CreateEntity,
    GetPlanSummary,
    GetValue,
    UpdateCampaign,
    GetCurrentTime,
    GetLatestPlan,
    UpdateCampaignBurst
} from '../../../services/CampaignsDataService';
import { adios, Modal, useModal } from '@adserve/adserve-react-components';
import axios from 'axios';
import { starter2Api } from '../../../constants/Endpoint';
import { dummyCampaignGoals } from './AirtimePlanningUtils';
import PlanProgress from './PlanProgress';
import { pageContainerStyle } from '../CampaignStyles';
import { AirtimePlanningContext } from '../../../contexts/AirtimePlanningContext';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';
import moment from 'moment';
import { withOutTimeZoneDate } from '../../../services/DateService';

const AirtimePlanning = ({ campaign, campaignVersionId, recalc, changeMade, readOnly, campaignBurst, isBurst }) => {
    // TODO: Move any daypartset logic to parent level once this is confirmed to be OK
    const pageShowing = useRef(null);

    const {
        canQuote,
        reservedUntil,
        setReservedUntil,
        currentPlan,
        setCurrentPlan,
        campaignBursts,
        setCampaignBursts,
        propertyStats,
        setPropertyStats,
        planIsInvalid,
        setPlanIsInvalid,
        currentCampaignVersionId,
        fetchCampaignPropertyStats
    } = useContext(AirtimePlanningContext);
    const { formatNumber } = useContext(SystemSettingsContext);
    const goals = dummyCampaignGoals();
    const [isPlanning, setIsPlanning] = useState(false);
    const [pleaseWaitId, setPleaseWaitId] = useState('');
    const [percentComplete, setPercentComplete] = useState(0);
    const [waitMessageText, setWaitMessageText] = useState(0);
    const [selectedStationId, setSelectedStationId] = useState(window.emptyGuid);
    const [selectedPlanId, setSelectedPlanId] = useState(0);
    const [planSummary, setPlanSummary] = useState([]);
    const [hasPlan, setHasPlan] = useState(false);
    const [showImpacts, setShowImpacts] = useState(false);
    const [showBaseImpacts, setShowBaseImpacts] = useState(true);
    const [planExpired, setPlanExpired] = useState(false);
    const [selectedBurstId, setSelectedBurstId] = useState(campaignBurst?.id);
    const [totalAirtimeCost, setTotalAirtimeCost] = useState();
    const [renderHack, setRenderHack] = useState(0);
    const [mounted, setMounted] = useState(false);

    const [sandPSave, setSandPSave] = useState(false);
    const { addMessage } = useModal();

    const handleStationChange = (event) => {
        setSelectedStationId(event.target.value);
    };
    const getLatestPlan = async () => {
        const plan = await GetLatestPlan(campaign.id, campaignBurst?.id);
        if (plan?.id && plan.id !== currentPlan?.id) {
            setCurrentPlan(plan);
        }
    };
    useEffect(() => {
        if (mounted) {
            if (planIsInvalid) {
                setCurrentPlan(null);
                setSelectedPlanId(0);
            } else {
                if (
                    campaign?.businessType === BusinessTypes.AIRTIMEBURST.name ||
                    (currentCampaignVersionId === window.emptyGuid && campaign?.campaignVersionId !== undefined)
                ) {
                    getLatestPlan();
                } else {
                    setCurrentPlan(campaign?.currentPlan);
                }
            }

            GetCampaignBursts(campaign.id).then((data) => {
                setCampaignBursts(data);
            });
        }
    }, [campaign, campaignBurst, mounted]);

    useEffect(() => {
        if (
            mounted &&
            totalAirtimeCost &&
            (campaign?.businessType === BusinessTypes.AIRTIME || campaign?.businessType === 'AirTime')
        ) {
            const cost = parseFloat(formatNumber(totalAirtimeCost).replace(',', ''));
            if (cost !== campaign.budget) {
                const goal = campaign.campaignGoal.find((s) => s.selected);
                if (goal.goal !== 'weeklyBudget' && goal.goal !== 'budget') {
                    updateBudget(cost);
                }
            }
        }
    }, [totalAirtimeCost]);

    const updateBudget = async (cost) => {
        const campaignObject = { ...campaign, budget: cost };
        await UpdateCampaign(campaignObject);
        changeMade('budget', cost);
    };

    useEffect(() => {
        const reserveDate =
            currentPlan?.quoteId !== undefined &&
            currentPlan?.quoteId !== window.emptyGuid &&
            currentPlan?.quote?.approvalStatus === 0
                ? withOutTimeZoneDate(currentPlan?.reservedUntil)
                : moment(currentPlan?.reservedUntil);
        setHasPlan(!!currentPlan?.id && new Date(reserveDate).getFullYear() !== 1);
        setReservedUntil(reserveDate);
    }, [currentPlan]);

    const getPlanSummary = (planId, stationId = 0, bursts = undefined) => {
        if (planIsInvalid) {
            setPlanSummary([]);
            return;
        }

        let pid = planId;

        if (selectedBurstId) {
            const localBursts = bursts ?? campaignBursts;
            const burst = localBursts.find((b) => b.id === selectedBurstId);

            if (burst) {
                if (campaignVersionId === window.emptyGuid) {
                    pid = burst.planId;
                }
            } else {
                pid = undefined;
            }
        }
        if (pid) {
            GetPlanSummary(pid, stationId, campaignVersionId, !!selectedBurstId)
                .then((result) => {
                    setPlanSummary(result);
                })
                .catch((error) => {
                    setErrorState(error.response.title);
                    setPlanSummary([]);
                });
        }
    };

    useEffect(() => {
        if (campaign.currentPlan?.id) {
            setSelectedPlanId(campaign.currentPlan?.id);
        }
        setMounted(true);
    }, []);

    useEffect(() => {
        getPlanSummary(campaignBurst ? campaignBurst.currentPlan?.id : campaign.currentPlan?.id, selectedStationId);
    }, [selectedBurstId, selectedStationId, campaignBursts]);

    useEffect(() => {
        getPlanSummary(campaignBurst ? campaignBurst.currentPlan?.id : campaign.currentPlan?.id, selectedStationId);
    }, [currentPlan]);

    function sleep(milliseconds) {
        // eslint-disable-next-line no-undef
        return new Promise((resolve) => setTimeout(resolve, milliseconds));
    }

    const [waitMessageCounter, setWaitMessageCounter] = useState(0);

    useEffect(() => {
        waitMessages();
    }, [waitMessageCounter]);

    const waitMessages = async () => {
        if (isPlanning && pageShowing.current) {
            const messg = await GetValue('WaitMessage', pleaseWaitId);
            const progressIdx = messg?.message?.indexOf('Completed');

            let calcPercent = 0;
            if (messg?.message?.includes('Completed')) {
                calcPercent =
                    parseInt(messg?.message?.substring(progressIdx + 10, progressIdx + 13)) /
                    (campaignBurst ? campaignBurst.burstStations.length : campaign.campaignStations.length);

                setPercentComplete(calcPercent);
            } else {
                setPercentComplete(0);
                setWaitMessageText(messg?.message);
            }

            await sleep(500);
            if (calcPercent < 1) {
                setWaitMessageCounter(waitMessageCounter + 1);
            }
            if (messg?.message?.includes('Optimisation Complete')) {
                console.log('getting latest from waitmessage');
                setIsPlanning(false);
                getLatestPlan();
            }
        }
    };

    useEffect(() => {
        if (pleaseWaitId && isPlanning) {
            waitMessages(pleaseWaitId);
        }
    }, [pleaseWaitId, isPlanning]);

    const updateAndSave = () => {
        UpdateCampaign(campaign, propertyStats).then((x) => {
            if (campaignBurst) {
                UpdateCampaignBurst(campaignBurst).then((y) => {
                    changeMade();
                    generatePlan(0);
                });
            } else {
                changeMade();
                generatePlan(0);
            }
        });
    };

    useEffect(() => {
        if (sandPSave) {
            updateAndSave();
            setSandPSave(false);
        }
    }, [sandPSave]);

    const saveAndGeneratePlan = () => {
        // alert('removing json cos it is broken dont leave in');
        // campaign.poNumbersJson = '{}';

        if (campaign?.campaignTypeName?.toLowerCase() === BusinessTypes.SANDP.name.toLowerCase()) {
            fetchCampaignPropertyStats(campaign?.id)
                .then((data) => {
                    setPropertyStats(data?.propertiesStats);
                    setSandPSave(true);
                })
                .catch((e) => {
                    addMessage({
                        message: window.translate('There was an error fetching the parent Campaign to save'),
                        buttons: [
                            {
                                text: window.translate('OK'),
                                callback: null
                            }
                        ]
                    });
                });
        } else {
            updateAndSave();
        }
    };
    useEffect(() => {
        if (campaign.generatePlan) saveAndGeneratePlan(0);
        campaign.generatePlan = false;
    }, [campaign.generatePlan]);

    const generatePlan = async (currentGoal) => {
        setPercentComplete(0);
        const msg = await CreateEntity('WaitMessage', {});

        setPleaseWaitId(msg.data.id);
        setPlanSummary([]);
        setIsPlanning(true);
        const mode = goals[currentGoal];
        await recalc(campaignBurst ? campaignBurst.burstStations : campaign.campaignStations, false);
        const planRequest = {
            externalSource: 'adservessp',
            campaignId: campaign.id,
            campaignBurstId: campaign.businessType === BusinessTypes.AIRTIMEBURST.name ? campaignBurst.id : undefined,
            deliveryMode: mode.name,
            dealVersionId: campaign.dealVersionId,
            startDate:
                campaign.businessType === BusinessTypes.AIRTIMEBURST.name
                    ? campaignBurst.startDate
                    : campaign.startDate,
            endDate:
                campaign.businessType === BusinessTypes.AIRTIMEBURST.name ? campaignBurst.endDate : campaign.endDate,
            budget:
                campaign.businessType === BusinessTypes.AIRTIMEBURST.name
                    ? campaignBurst.budget // campaign.campaignGoal.find((s) => s.selected).burstValue
                    : campaign.budget,
            quoteDelivery: [currentGoal],
            surveyId: campaign.surveyId,
            targetDemoId: campaign.demographicId,
            stations: (campaignBurst ? campaignBurst.burstStations : campaign.campaignStations).map((st, i) => {
                return {
                    id: st.id,
                    stationGuid: st.id,
                    name: st.name,
                    cpt: st.cpt,
                    budget: st.budget
                };
            }),
            exclusions: campaignBurst ? campaignBurst.exclusions : campaign.exclusions,
            applicableDayParts: campaignBurst ? campaignBurst.applicableDayParts : campaign.applicableDayParts,
            copyTypes: campaignBurst ? campaignBurst.copyTypes : campaign.copyTypes,
            campaignGoal: campaign.campaignGoal,
            waitMessageId: msg.data.id,
            ignoreAvailability: campaignBurst
                ? !campaignBurst.advancedOptions?.respectAvailability
                : !campaign?.advancedOptions?.respectAvailability,
            airTimeStartHour: campaignBurst
                ? campaignBurst.advancedOptions?.airtimeStartHour
                : campaign?.advancedOptions?.airtimeStartHour,
            airTimeEndHour: campaignBurst
                ? campaignBurst.advancedOptions?.airtimeEndHour
                : campaign?.advancedOptions?.airtimeEndHour,
            endEveryday: campaignBurst
                ? campaignBurst.advancedOptions?.endEveryday
                : campaign?.advancedOptions?.endEveryday,
            startEveryday: campaignBurst
                ? campaignBurst.advancedOptions?.startEveryday
                : campaign?.advancedOptions?.startEveryday,
            currentDateTime: GetCurrentTime()
        };

        const goal = isBurst
            ? campaignBurst.campaignGoal.find((s) => s.selected)
            : campaign.campaignGoal.find((s) => s.selected);

        if (campaign.businessType.toLowerCase() === BusinessTypes.AIRTIME.name.toLowerCase() || campaignBurst) {
            planRequest.budget = goal.value;
        }

        if (campaign.businessType.toLowerCase() === BusinessTypes.SANDP.name.toLowerCase() && !campaignBurst) {
            planRequest.sandPPropertyId = campaign.sandPPropertyId;
        }

        planRequest.mode = goal.goal;
        planRequest.dayWeights = campaignBurst ? campaignBurst.dayWeights : campaign.dayWeights;
        planRequest.campaignShapeId = campaign.campaignShapeId;
        //planRequest.weekWeights = campaignBurst ? campaignBurst.budgetAllocations : campaign.budgetAllocations;

        planRequest.weekWeights = null;
        if (goal.goal === 'weeklyBudget') {
            planRequest.budget = goal?.values?.reduce((a, b) => {
                return a + parseFloat(b.value);
            }, 0);

            const weekWeights = [];
            for (let index = 0; index < goal.values.length; index++) {
                const week = goal.values[index];
                weekWeights.push({ id: index, weight: (week.value / planRequest.budget) * 100 });
            }

            planRequest.weekWeights = weekWeights;
        }

        adios(() => axios.post(`${starter2Api}/PlanOptimisationRequest`, planRequest))
            .then((result) => {
                const cPlan = result.data;
                if (typeof cPlan.reservedUntil === 'string') {
                    const revDate = moment(cPlan?.reservedUntil);
                    // TODO once DateTime issue with TimeZone is fixed dateAppliedTimezone needs to be removed
                    // // These lines need to be commented out if using locally
                    // revDate = new Date(
                    //     revDate?.getTime() +
                    //         revDate?.getTimezoneOffset() * 60 * 1000
                    // );
                    // // end of lines need to be commmented out
                    cPlan.reservedUntil = revDate;
                    setReservedUntil(revDate);
                }

                if (!isBurst) {
                    if (!campaign?.advancedOptions?.respectAvailability) {
                        cPlan.reservedUntil = new Date(new Date().getTime() - 30 * 60 * 1000);
                        setReservedUntil(cPlan.reservedUntil);
                    }
                } else {
                    if (!campaignBurst?.advancedOptions?.respectAvailability) {
                        cPlan.reservedUntil = new Date(new Date().getTime() - 30 * 60 * 1000);
                        setReservedUntil(cPlan.reservedUntil);
                    }
                }

                setCurrentPlan(cPlan);
                setSelectedPlanId(cPlan.id);
                setPlanIsInvalid(false);
                GetCampaignBursts(campaign.id).then((data) => {
                    setCampaignBursts(data);

                    setIsPlanning(false);
                    changeMade('currentPlan', cPlan);

                    getPlanSummary(cPlan?.id, 0, data);

                    if (campaignBurst) {
                        changeMade('PlanId', cPlan?.id);
                        setRenderHack(renderHack + 1);
                    }
                });

                // setIsPlanning(false);
                // changeMade('currentPlan', cPlan);

                // getPlanSummary(cPlan?.id);
            })
            .catch((error) => {
                console.log(error);
                setIsPlanning(false);
                setErrorState(error.response.data.title);
            });
    };

    const goPlan = (goal) => {
        if (campaign.reservedQuoteId) {
            alert('dialog to dereserve here instead');
        }

        if (!isPlanning) {
            saveAndGeneratePlan(goal);
        }
    };

    const [errorState, setErrorState] = useState('');
    return (
        <div ref={pageShowing} style={pageContainerStyle}>
            <Modal isShowing={errorState} hide={() => setErrorState(false)}>
                {errorState}
            </Modal>
            <div style={summaryPanelStyle}>
                {isPlanning && <PlanProgress percentComplete={percentComplete} message={waitMessageText} />}
                <PlanManager
                    plan={currentPlan}
                    selectedBurstId={selectedBurstId}
                    setSelectedBurstId={setSelectedBurstId}
                    campaignBursts={campaignBursts}
                    readOnly={readOnly}
                    reservedUntil={reservedUntil}
                    goals={goals}
                    updateGoal={goPlan}
                    campaign={campaign}
                    setErrorState={setErrorState}
                    hasPlan={hasPlan}
                    planning={isPlanning}
                    canQuote={canQuote(campaign)}
                    selectedStationId={selectedStationId}
                    selectedPlanId={selectedPlanId}
                    stationChange={handleStationChange}
                    planExpired={planExpired}
                    setPlanExpired={setPlanExpired}
                    lastPlanIsBooked={currentPlan?.quote?.status === 2}
                    setSelectedStationId={setSelectedStationId}
                    showImpacts={showImpacts}
                    showBaseImpacts={showBaseImpacts}
                    totalAirtimeCost={totalAirtimeCost}
                    renderHack={renderHack}
                />
                <PlanChart
                    hasPlan={hasPlan && planSummary?.dayParts?.length > 0}
                    planSummary={planSummary.dayParts}
                    quoteExpired={!hasPlan}
                    isPlanning={isPlanning}
                    showImpacts={showImpacts}
                    setShowImpacts={setShowImpacts}
                    showBaseImpacts={showBaseImpacts}
                    setShowBaseImpacts={setShowBaseImpacts}
                    planExpired={planExpired && currentPlan?.quote?.status !== 2}
                />
                <PlanSummary
                    hasPlan={hasPlan && !isPlanning && planSummary?.dayParts?.length > 0}
                    planSummary={planSummary}
                    planId={currentPlan?.id}
                    stationId={selectedStationId}
                />
            </div>

            <div style={{ height: 16 }} />

            <div style={deliveryPanelStyle}>
                <PlanDelivery
                    hasPlan={hasPlan && !isPlanning && planSummary?.dayParts?.length > 0}
                    planSummary={planSummary?.dayParts}
                    showImpacts={showImpacts}
                    showBaseImpacts={showBaseImpacts}
                    setTotalAirtimeCost={setTotalAirtimeCost}
                />
            </div>
        </div>
    );
};

export default AirtimePlanning;
